export default __webpack_public_path__ + "static/media/investors-other.1668feb3.wav";